import React, { useState, useEffect } from "react";
import {
  getGlobalSetting,
  updateGlobalSetting,
} from "../../../services/AdminService";
import { useAxiosInstance } from "../../../services/Interceptor";
import { toast } from "react-toastify";

const GraduatedClass = () => {
  const [graduatedClass, setGraduatedClass] = useState("");
  const [loadingGraduatedClass, setLoadingGraduatedClass] = useState(false);
  const apiInstance = useAxiosInstance();

  useEffect(() => {
    const fetchGraduatedClass = async () => {
      try {
        const response = await getGlobalSetting(apiInstance, "graduatedClass");
        const value = response?.data ?? response;
        setGraduatedClass(value?.toString() ?? "");
      } catch (err) {
        toast.error("Failed to load graduated class");
      }
    };

    fetchGraduatedClass();
  }, [apiInstance]);

  const handleGraduatedClassSave = async () => {
    setLoadingGraduatedClass(true);
    try {
      await updateGlobalSetting(apiInstance, "graduatedClass", graduatedClass);
      toast.success("Graduated class updated successfully");
    } catch (err) {
      const errorMessage =
        err?.response?.data?.error || "Failed to update graduated class";
      toast.error(errorMessage);
    } finally {
      setLoadingGraduatedClass(false);
    }
  };

  return (
    <div className="mb-6">
      <label className="font-medium text-gray-900 block mb-1">
        Graduated Class
      </label>
      <div className="flex flex-col items-end sm:flex-row gap-2 md:gap-6">
        <div className="w-full sm:w-3/4">
          <input
            type="text"
            value={typeof graduatedClass === "string" ? graduatedClass : ""}
            onChange={(e) => setGraduatedClass(e.target.value)}
            placeholder="Ej: 2024"
            className="block w-full mt-2 rounded-md border-0 py-3 pl-4 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-600"
          />{" "}
        </div>
        <div className="w-full sm:w-1/4">
          <button
            onClick={handleGraduatedClassSave}
            disabled={loadingGraduatedClass}
            className="bg-red-500 text-white uppercase rounded px-4 py-2 text-center hover:bg-red-700 cursor-pointer  sm:w-full sm:px-4 sm:py-2 sm:text-sm"
          >
            {loadingGraduatedClass ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GraduatedClass;
